module.exports = __webpack_public_path__ + "spinner.5204de31.gif";


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/images/spinner.gif
// module id = 1328
// module chunks = 1